import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-video-iq-checklist',
  templateUrl: './help-youtube-video-iq-checklist.component.html'
})
export class HelpYoutubeVideoIqChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
